import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズの IT Operation Core ロゴアイコン
 */
export function ProductLogoMediumITOperationCore({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 672 672" fill="none" {...props}>
      <rect width={672} height={672} fill="#1A2142" rx={100} />
      <path fill="#FCFCFD" d="M144 216c0-13.255 10.745-24 24-24h312c13.255 0 24 10.745 24 24H144ZM144 216h24v180h-24V216ZM480 216h24v16a8 8 0 0 1-8 8h-8a8 8 0 0 1-8-8v-16ZM144 396h220a8 8 0 0 1 8 8v40H144v-48Z" />
      <path fill="#57D7D9" d="M372 460a8 8 0 0 1-8 8H146.4c-21.207 0-38.4-17.193-38.4-38.4a9.6 9.6 0 0 1 9.6-9.6H300v12c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12v-12h24v40Z" />
      <path fill="#57D7D9" fillRule="evenodd" d="M499.029 281a12 12 0 0 1 8.486 3.515l40.97 40.97a12 12 0 0 1 3.515 8.486V485c0 6.627-5.373 12-12 12H420c-6.627 0-12-5.373-12-12V293c0-6.627 5.373-12 12-12h79.029ZM432 349a8 8 0 0 1 8-8h80a8 8 0 0 1 8 8v8a8 8 0 0 1-8 8h-80a8 8 0 0 1-8-8v-8Zm8 40a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-8a8 8 0 0 0-8-8h-80Zm0 48a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-8a8 8 0 0 0-8-8h-80Z" clipRule="evenodd" />
      <path fill="#fff" d="M548.586 325.586c1.26 1.26.367 3.414-1.414 3.414H512a8 8 0 0 1-8-8v-35.172c0-1.781 2.154-2.674 3.414-1.414l41.172 41.172Z" />
    </svg>;
}